import React, { useEffect, useState, useRef } from 'react';
import { ChefHat, Wine, Users as UsersIcon, Award, Shield, UserCheck } from 'lucide-react';
import { teamRoles } from '../data/mockData';

const teamIcons = [UserCheck, Wine, ChefHat, ChefHat, Award, UsersIcon, Shield, Shield, Shield, UserCheck, UserCheck, ChefHat];

const TeamSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} id="equipe" className="py-20 md:py-28 bg-[#111111]">
      <div className="max-w-6xl mx-auto px-6">
        <div
          className={`text-center mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
          }`}
        >
          <span className="font-body text-xs tracking-[0.3em] uppercase text-[#C9A961]">Nossa equipe</span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-white mt-3 mb-4">
            Profissionais dedicados ao seu evento
          </h2>
          <p className="font-body text-sm text-white/50 max-w-lg mx-auto">
            Toda nossa equipe é inclusa no orçamento. Você não paga nada a mais.
          </p>
          <div className="w-12 h-[2px] bg-gradient-to-r from-[#8B6F47] to-[#C9A961] mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {teamRoles.map((member, i) => {
            const Icon = teamIcons[i] || Award;
            return (
              <div
                key={member.role}
                className={`group text-center p-5 rounded-sm border border-white/10 hover:border-[#8B6F47]/40 bg-[#0a0a0a] transition-all duration-500 hover:shadow-lg hover:shadow-[#8B6F47]/10 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full border border-[#8B6F47]/20 group-hover:border-[#8B6F47]/50 group-hover:bg-[#8B6F47]/10 transition-all">
                  <Icon className="w-5 h-5 text-[#C9A961]" />
                </div>
                <h3 className="font-display text-base text-white mb-1">{member.role}</h3>
                <p className="font-body text-xs text-white/40 leading-relaxed">{member.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
